import React from 'react';
import classNames from 'classnames';

import css from './Icons.module.css';

const CountertopIcon = ({ className, viewBox }) => {
  return (

    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="a"
      viewBox="0 0 45.267 44.804"
      className={classNames(css.root, className)}
    >
      <path
        fill="none"
        stroke="#535454"
        strokeMiterlimit="10"
        strokeWidth="1.25"
        d="M16.627 40.748c0 .053-.108.096-.242.096s-.242-.043-.242-.096"
      ></path>
      <ellipse
        cx="16.386"
        cy="2.557"
        fill="none"
        stroke="#535454"
        strokeMiterlimit="10"
        strokeWidth="1.25"
        rx="3.118"
        ry="0.963"
      ></ellipse>
      <path
        fill="none"
        stroke="#535454"
        strokeMiterlimit="10"
        strokeWidth="1.25"
        d="M16.402 30.985c-3.228 0-5.472-8.438-7.511-12.435-.716-1.404-3.283-3.648-4.56-3.894 0 0 .248-1.906 1.276-2.46 2.489-1.341 3.686-.714 5.025-1.791 1.492-1.199 2.286-2.322 2.437-4.447.099-1.399.225-3.489.225-3.489"
      ></path>
      <path
        fill="none"
        stroke="#535454"
        strokeMiterlimit="10"
        strokeWidth="1.25"
        d="M16.394 30.987c3.228 0 5.472-8.438 7.511-12.435.716-1.404 3.283-3.648 4.56-3.894 0 0-.248-1.906-1.276-2.46-2.489-1.341-3.686-.714-5.025-1.791-1.492-1.199-2.286-2.322-2.437-4.447-.099-1.399-.225-3.489-.225-3.489M16.136 40.808v-9.42h.488v9.42"
      ></path>
      <ellipse
        cx="16.39"
        cy="40.971"
        fill="none"
        stroke="#535454"
        strokeMiterlimit="10"
        strokeWidth="1.25"
        rx="8.737"
        ry="2.37"
      ></ellipse>
      <path
        fill="none"
        stroke="#535454"
        strokeMiterlimit="10"
        strokeWidth="1.25"
        d="M26.572 31.166h14.172v5.594H26.572zM28.471 24.715h10.373v4.095H28.471zM30.348 19.777h6.619v2.613h-6.619z"
      ></path>
      <path
        fill="none"
        strokeWidth="0"
        d="M-.057.095h45.189v44.744H-.057z"
      ></path>
    </svg>
  );
};

export default CountertopIcon;
